import { render } from "./DesignItem.vue?vue&type=template&id=10e98ce9"
import script from "./DesignItem.vue?vue&type=script&lang=js"
export * from "./DesignItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__